export default "__VITE_ASSET__DNmKJmaa__"